import * as Sentry from '@sentry/browser';
import { useQuery } from '@tanstack/react-query';

import LedOffersService from '~/services/LedOffersService';

import { ledOffersQueryKeys } from './ledOffersQueryKeys';

export interface BundledExperience {
  /** Synthetic index used as DataGrid row identifier (not an API field) */
  rowIndex: number;
  name: string;
  fare_type_display: string;
  rrp: number;
  book_by_date: string;
  travel_to_date: string;
  converted_cost_aud: number;
  sell_price_uplift: number;
  currencyisocode: string;
  is_luxplus_exclusive: boolean;
}

interface UseFetchBundledExperiencesParams {
  dealSalesforceId: string;
  enabled?: boolean;
}

export function useFetchBundledExperiences({ dealSalesforceId, enabled = true }: UseFetchBundledExperiencesParams) {
  return useQuery({
    queryKey: ledOffersQueryKeys.bundledExperiencesByDealOption(dealSalesforceId),
    queryFn: async () => {
      try {
        const response = await LedOffersService.getBundledExperiences(dealSalesforceId);
        return (response.result ?? []).map((item: Omit<BundledExperience, 'rowIndex'>, index: number) => ({
          ...item,
          rowIndex: index,
        }));
      } catch (error) {
        Sentry.captureException(error, {
          tags: {
            hook: 'useFetchBundledExperiences',
            dealSalesforceId,
          },
        });
        return [];
      }
    },
    enabled: enabled && !!dealSalesforceId,
  });
}
